var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTumblr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5575 17.7713C2.5217 18.5991 2.63521 19.4267 2.89259 20.2143C3.15999 20.834 3.57343 21.3798 4.0976 21.805C4.71361 22.3245 5.42707 22.7158 6.1962 22.9562C7.11232 23.2402 8.06777 23.3769 9.02679 23.361C9.90935 23.3669 10.7897 23.2721 11.6508 23.0786C12.5858 22.8435 13.494 22.5124 14.3608 22.0904V18.417C13.3246 19.1431 12.0958 19.5447 10.8308 19.5707C10.2081 19.5822 9.59434 19.421 9.05769 19.1049C8.69083 18.902 8.40748 18.5759 8.25769 18.1844C8.06665 17.3289 7.99438 16.4513 8.04289 15.5761V9.58398H13.5905V5.91699H8.0432V0H4.7343C4.6334 1.03041 4.35768 2.03608 3.91899 2.97388C3.53504 3.73975 3.00115 4.4207 2.349 4.97629C1.65779 5.55327 0.859551 5.98823 0 6.25629V9.58398H2.5576L2.5575 17.7713Z",
    fill: "#535F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumblr);
export default __webpack_public_path__ + "static/media/Tumblr.7e8b62576ea273056d5cac0fbb8bc097.svg";
export { ForwardRef as ReactComponent };